"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.query = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.array.sort");
/* Formerly "Knowledge", now "Inspiration"
 * Calling it "Articles" now to keep it nice and generic.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _layouts_1 = require("@layouts");
const atoms_1 = require("@components/atoms");
const molecules_1 = require("@components/molecules");
const organisms_1 = require("@components/organisms");
const _utils_1 = require("@utils");
// Component
var InspirationPage = function InspirationPage(_ref) {
    var _ref$data = _ref.data, contentfulKnowledgeLandingPage = _ref$data.contentfulKnowledgeLandingPage, allContentfulKnowledge = _ref$data.allContentfulKnowledge, allContentfulKnowledgeCategory = _ref$data.allContentfulKnowledgeCategory;
    if (!contentfulKnowledgeLandingPage)
        return null;
    var title = contentfulKnowledgeLandingPage.title, seoTitle = contentfulKnowledgeLandingPage.seoTitle;
    var _React$useState = react_1.default.useState(9), postsToShow = _React$useState[0], setPostsToShow = _React$useState[1];
    var _React$useState2 = react_1.default.useState([]), visibleArticles = _React$useState2[0], setVisibleArticles = _React$useState2[1];
    var _useHash = _utils_1.useHash(), currentCategory = _useHash[0], setCurrentCategory = _useHash[1];
    var _React$useState3 = react_1.default.useState(title), displayTitle = _React$useState3[0], setDisplayTitle = _React$useState3[1];
    var _React$useState4 = react_1.default.useState(""), displaySubhead = _React$useState4[0], setDisplaySubhead = _React$useState4[1];
    var _React$useState5 = react_1.default.useState([]), categoryLinks = _React$useState5[0], setCategoryLinks = _React$useState5[1];
    react_1.default.useEffect(function () {
        var articles = allContentfulKnowledge.edges.map(function (_ref2) {
            var node = _ref2.node;
            return node;
        }).filter(function (article) {
            var _article$title;
            return !_utils_1.checkPlaceholderContent(article === null || article === void 0 ? void 0 : (_article$title = article.title) === null || _article$title === void 0 ? void 0 : _article$title.title);
        }).sort(function (a, b) {
            var dateA = new Date(a.datePublishedRaw);
            var dateB = new Date(b.datePublishedRaw);
            return dateB.valueOf() - dateA.valueOf();
        });
        if (currentCategory.substr(1) !== "") {
            setVisibleArticles(articles.filter(function (article) {
                var _article$categories;
                return (_article$categories = article.categories) === null || _article$categories === void 0 ? void 0 : _article$categories.some(function (cat) {
                    return (cat === null || cat === void 0 ? void 0 : cat.slug) === currentCategory.substr(1);
                });
            }));
        }
        else {
            setVisibleArticles(articles);
        }
        setPostsToShow(8);
        if (currentCategory === "") {
            setDisplayTitle(title);
            setDisplaySubhead("");
        }
        else {
            var _allContentfulKnowled, _allContentfulKnowled2, _allContentfulKnowled3, _allContentfulKnowled4;
            var newTitle = (_allContentfulKnowled = allContentfulKnowledgeCategory.edges.find(function (c) {
                return c.node.slug === currentCategory.substr(1);
            })) === null || _allContentfulKnowled === void 0 ? void 0 : _allContentfulKnowled.node.brandedName;
            var newSubhead = (_allContentfulKnowled2 = allContentfulKnowledgeCategory.edges.find(function (c) {
                return c.node.slug === currentCategory.substr(1);
            })) === null || _allContentfulKnowled2 === void 0 ? void 0 : (_allContentfulKnowled3 = _allContentfulKnowled2.node.caption) === null || _allContentfulKnowled3 === void 0 ? void 0 : (_allContentfulKnowled4 = _allContentfulKnowled3.childMarkdownRemark) === null || _allContentfulKnowled4 === void 0 ? void 0 : _allContentfulKnowled4.html;
            setDisplayTitle(newTitle);
            setDisplaySubhead(newSubhead);
        }
        var newCategoryLinks = [{
                label: 'Latest',
                onClick: function onClick() {
                    return setCurrentCategory('');
                },
                active: currentCategory === ""
            }];
        allContentfulKnowledgeCategory.edges.sort(function (a, b) {
            var _a$node, _b$node;
            return (a === null || a === void 0 ? void 0 : (_a$node = a.node) === null || _a$node === void 0 ? void 0 : _a$node.order) - (b === null || b === void 0 ? void 0 : (_b$node = b.node) === null || _b$node === void 0 ? void 0 : _b$node.order);
        }).map(function (edge) {
            if (edge === null || edge.node.slug === 'announcement')
                return null;
            newCategoryLinks.push({
                label: edge.node.name,
                onClick: function onClick() {
                    return setCurrentCategory(edge.node.slug);
                },
                active: edge.node.slug === currentCategory.substr(1)
            });
        });
        setCategoryLinks(newCategoryLinks);
    }, [currentCategory]);
    var loadMore = function loadMore() {
        return setPostsToShow(postsToShow + 8);
    };
    var quickLinksBar = /*#__PURE__*/ react_1.default.createElement(molecules_1.QuickLinksBar, {
        links: categoryLinks
    });
    var calcTeaserLayout = function calcTeaserLayout(index) {
        var pattern = ['center', 'float', 'float', 'float', 'corner', 'float', 'float', 'float'];
        return pattern[index % pattern.length];
    };
    return /*#__PURE__*/ react_1.default.createElement(_layouts_1.Layout, {
        subHeaderContent: quickLinksBar
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.SeoTags, {
        title: seoTitle,
        urlPath: "/inspiration"
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.PageHeader, {
        title: displayTitle,
        subhead: displaySubhead
    }), /*#__PURE__*/ react_1.default.createElement(TeaserList, null, visibleArticles.filter(function (_, i) {
        return i < postsToShow;
    }).map(function (article, index) {
        var _article$title2, _article$categories2, _article$categories2$, _article$homepageExce, _article$homepageExce2, _article$indexImage, _article$indexImage$f, _article$heroImage, _article$heroImage$fi, _article$heroImage2, _article$heroImage2$f, _article$heroImage3, _article$heroImage3$f;
        return /*#__PURE__*/ react_1.default.createElement(molecules_1.ArticleTeaser, {
            key: article.slug,
            title: (_article$title2 = article.title) === null || _article$title2 === void 0 ? void 0 : _article$title2.title,
            eyebrowLabel: (_article$categories2 = article.categories) === null || _article$categories2 === void 0 ? void 0 : (_article$categories2$ = _article$categories2[0]) === null || _article$categories2$ === void 0 ? void 0 : _article$categories2$.name,
            description: (_article$homepageExce = article.homepageExcerpt) === null || _article$homepageExce === void 0 ? void 0 : (_article$homepageExce2 = _article$homepageExce.childMarkdownRemark) === null || _article$homepageExce2 === void 0 ? void 0 : _article$homepageExce2.html,
            url: article.slug ? "/inspiration/" + article.slug : "/404",
            floatingImageUrl: ((_article$indexImage = article.indexImage) === null || _article$indexImage === void 0 ? void 0 : (_article$indexImage$f = _article$indexImage.file) === null || _article$indexImage$f === void 0 ? void 0 : _article$indexImage$f.url) || ((_article$heroImage = article.heroImage) === null || _article$heroImage === void 0 ? void 0 : (_article$heroImage$fi = _article$heroImage.file) === null || _article$heroImage$fi === void 0 ? void 0 : _article$heroImage$fi.url),
            heroImageUrl: (_article$heroImage2 = article.heroImage) === null || _article$heroImage2 === void 0 ? void 0 : (_article$heroImage2$f = _article$heroImage2.file) === null || _article$heroImage2$f === void 0 ? void 0 : _article$heroImage2$f.url,
            mobileHeroImageUrl: (_article$heroImage3 = article.heroImage) === null || _article$heroImage3 === void 0 ? void 0 : (_article$heroImage3$f = _article$heroImage3.file) === null || _article$heroImage3$f === void 0 ? void 0 : _article$heroImage3$f.url,
            layout: calcTeaserLayout(index),
            orientation: index % 2 ? 'right' : 'left'
        });
    }), visibleArticles.length < 1 && /*#__PURE__*/ react_1.default.createElement("h1", null, "No results."), postsToShow < visibleArticles.length && /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        onClick: function onClick() {
            return loadMore();
        },
        type: "outline",
        size: "large",
        center: true,
        lines: true
    }, "Load More")), /*#__PURE__*/ react_1.default.createElement(molecules_1.RegisterInLayout, null), /*#__PURE__*/ react_1.default.createElement(organisms_1.HomepageHero, null));
}; // Styling
// note: if this shares anything with TeaserList on landing page, turn into molecule
var TeaserList = styled_components_1.default.div.withConfig({
    displayName: "inspiration__TeaserList",
    componentId: "sc-1d74yma-0"
})([""]); // Typing
// Data
exports.query = "1338859376";
exports.default = InspirationPage;
